import React from 'react';

const Title = () =>
  <div className="title-background">
    <div className="container title-block -mobile">
      <img src="./images/title-mobile.svg" alt="" />
      <div className="content">
        臺灣的觀光外匯收入占臺灣總外匯收入的比例呈現逐漸成長的趨勢，觀光業是一個開放的市場，不僅帶來外匯收入，
        更進一步影響國家的經濟發展。臺灣的觀光族群都來自於哪些國家？各國來臺人口成長率是否有大幅度差異？匯率的走勢是否影響來臺觀光的人數？
        我們分析三年的觀光統計數據，利用數據與民眾對話，比較各國來臺遊客的人數及匯率走勢之間的關係。
      </div>
    </div>
    <div className="container title-block -desktop">
      <div className="title-subblock">
        <img src="./images/title-desktop.svg" alt="Visitors to taiwan 造訪台灣的外籍旅客們" width="100%" height="auto" />
        <p className="intro -spacing">
          臺灣的觀光外匯收入占臺灣總外匯收入的比例呈現逐漸成長的趨勢，觀光業是一個開放的市場，不僅帶來外匯收入，更進一步影響國家的經濟發展。
        </p>
      </div>
      <div className="title-subblock">
        <img src="./images/people-02.svg" alt="Visitors to taiwan 造訪台灣的外籍旅客們" />
      </div>
      <div className="title-subblock">
        <p className="intro">
          <span className="underline">
            臺灣的觀光族群都來自於哪些國家？各國來臺人口成長率是否有大幅度差異？匯率的走勢是否影響來臺觀光的人數？
          </span>
        我們分析三年的觀光統計數據，利用數據與民眾對話，比較各國來臺遊客的人數及匯率走勢之間的關係。</p>
      </div>
      {/* <h1 className="main-title">VISITORS<br />TO TAIWAN</h1>
      <h2 className="sub-title">造訪台灣的外籍旅客們</h2>
      <p className="intro">臺灣的觀光外匯收入占臺灣總外匯收入的比例呈現逐漸成長的趨勢，觀光業是一個開放的市場，不僅帶來外匯收入，更進一步影響國家的經濟發展。
      近年來觀光議題沸沸揚揚，隨著陸客開放來臺之後，大部分的觀光議題，皆圍繞在陸客身上，如今
        <span className="underline">
          臺灣的觀光族群都來自於哪些國家？各國來臺人口成長率是否有大幅度差異？匯率的走勢是否影響來臺觀光的人數？
        </span>
      我們分析三年的觀光統計數據，利用數據與民眾對話，比較各國來臺遊客的人數及匯率走勢之間的關係。</p>*/}
    </div>
  </div>;

export default Title;



/** WEBPACK FOOTER **
 ** ./src/components/title.js
 **/